export default {
  development: {
    VERSION: "2.0.0",
    SOCKETIO_newlogin: "newlogin" ,
    SOCKETIO_loggedin: "loggedin",
    // SOCKETIO_newlogin: "newlogin_uat" ,
    // SOCKETIO_loggedin: "newlogin_uat",
    IDLE_TIMEOUT: 2 * 60 * 60 * 1000, // 2Hr
    LEAFTECH_HOST: "https://maps.leafte.ch",
    // BACKEND_HOST: "https://digital.map.api.dev.rtic-thai.info/api/v1", // TDEM
    // BACKEND_HOST: "https://digital.map.api.rtic-thai.info/api/v1",  // NETH
    //BACKEND_HOST: "https://digital.map.api.dev.rtic-thai.info/api/v1", // NETH
    // BACKEND_HOST: "https://digital.map.lsp.web.api.nexty.rtic-thai.info/api/v1",
    BACKEND_HOST: "http://localhost:8000/api/v1",
    //SOCKETIO_URL: "https://digital.map.api.dev.rtic-thai.info",
    SOCKETIO_URL: "http://localhost:8000/api/v1", 
    // SOCKETIO_URL: "https://digital.map.lsp.web.api.nexty.rtic-thai.info/api/v1",
    // BACKEND_HOST : "http://dm_dev1.leafte.ch:8888/https://digital.map.api.rtic-thai.info/api/v1", 
    // BACKEND_HOST: "http://digital.map.api.dev.rtic-thai.info:6001/api/v1",
    //BACKEND_HOST: "http://digital.map.api.dev.rtic-thai.info:5000/api/v1",
    AUTHORIZATION : "1234567890-12345-12345678",
    // MAP_KEY : "AIzaSyAR8tDtV_F2TuYSqZHAkdAzG7g8Hif8Cz8"
    MAP_KEY : "AIzaSyCUCNt2DVRZWWB_1ep1KOb0W9Bdr_eiQMY"
  },
  production: {
    VERSION: "2.0.0",
    IDLE_TIMEOUT: 2 * 60 * 60 * 1000, // 2Hr
    BACKEND_HOST: "https://api.dmap.mobility-daas.com/api/v1", // EC2 (Traefik -> backend)
    AUTHORIZATION : "1234567890-12345-12345678",
    SOCKETIO_URL: "https://api.dmap.mobility-daas.com", // EC2 (Traefik -> backend, SocketIO)
    MAP_KEY : "AIzaSyCUCNt2DVRZWWB_1ep1KOb0W9Bdr_eiQMY",
  }
};
